/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZoomQuestion = createReactComponent("zoom-question", "IconZoomQuestion", [
  ["path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", key: "svg-0" }],
  ["path", { d: "M21 21l-6 -6", key: "svg-1" }],
  ["path", { d: "M10 13l0 .01", key: "svg-2" }],
  ["path", { d: "M10 10a1.5 1.5 0 1 0 -1.14 -2.474", key: "svg-3" }]
]);

export { IconZoomQuestion as default };
//# sourceMappingURL=IconZoomQuestion.js.map
